import {ExclamationTriangleIcon, XMarkIcon} from "@heroicons/react/24/outline";
import React from "react";


export default function SunsetBanner() {
    const [isWarningOpen, setWarningOpen] = React.useState(true);
    if (!isWarningOpen) {
        return null;
    }
    return (
        <div className='bg-gray-100 relative z-50 pointer-events-auto'>
            <div className="m-4 flex text-center justify-center items-center bg-red-100 border border-red-400 rounded-lg">
                <ExclamationTriangleIcon className='h-24 w-24 m-4 text-red-400'/>
                <div className="relative m-4 flex flex-col items-start">
                    <h1 className='font-bold text-lg mb-2'>AI Writing Assistant will be discontinued on May 30, 2025</h1>
                    <p className='text-left text-gray-700'>AI Writing Assistant will no longer be available in Semrush’s App Center after May 30.</p>
                    <p className='text-left text-gray-700'>No action is needed––your subscription will be stopped automatically before the next billing date.
                        As an alternative, check out our newest <a href='https://www.semrush.com/content/' target='_blank' className='text-blue-600'>Content Toolkit</a> — it helps you write articles that rank high.
                        If you have any questions or need assistance, contact us <a href='https://www.semrush.com/company/contacts/' target='_blank' className='text-blue-600'>using this link</a>.</p>
                </div>
                <div className='self-stretch ml-auto flex items-start justify-center cursor-pointer p-2' onClick={() => setWarningOpen(false)}>
                    <XMarkIcon className='h-4 w-4 text-gray-700' />
                </div>
            </div>
        </div>
    )
}
